<div class="table-responsive simplified-table" *ngIf="data?.Columns?.length">
  <table class="table table-striped table-sm mb-0">
    <thead>
      <tr>
        <th *ngFor="let col of data.Columns">
          {{ col.Title }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of _displayedRows">
        <td *ngFor="let col of data.Columns">
          {{ row[col.Key] }}
        </td>
      </tr>
    </tbody>
  </table>

  <div class="text-center py-4 no-data-message" *ngIf="_filteredRows.length === 0">
    <p class="text-muted">{{_appService.CoreCommonLiterals.NoDataFound}}</p>
  </div>

  <div class="col-sm-12 col-12 px-0 d-flex justify-content-sm-end align-items-end overflow-auto flex-column flex-sm-row pagination-controls" *ngIf="_filteredRows.length > 0">
    <div class="form-group mx-2 mb-2 mb-sm-0">
      <label for="itemsPerPage" class="mr-2">{{_appService.CoreCommonLiterals.RowsPerPage}}</label>
      <select id="itemsPerPage" class="form-control" [(ngModel)]="_itemsPerPage" (change)="onItemsPerPageChange(_itemsPerPage)">
          <option *ngFor="let option of _itemsPerPageOptions" [value]="option">{{ option }}</option>
      </select>
    </div>
    
    <button 
      id="reports-btn-start" 
      [disabled]="!_PreviousHidden" 
      type="button" 
      class="btn btn-secondary text-nowrap mr-2 mb-2 mb-sm-0" 
      (click)="movePage(-1, true)"
    >
      <span>&lsaquo;</span> {{ _appService.CoreCommonLiterals.FirstPage }}
    </button>
    
    <button
      id="reports-btn-previous"
      [disabled]="!_PreviousHidden"
      type="button"
      class="btn btn-secondary text-nowrap mr-2 mb-2 mb-sm-0"
      (click)="movePage(-1)"
    >
      <span>&laquo;</span> {{ _appService.CoreCommonLiterals.PreviousPage }}
    </button>
    
    <div class="d-flex align-items-center mx-2 mb-2 mb-sm-0" *ngIf="_totalPageCount > 1">
      <span class="text-nowrap">{{ _currentPageNumber }} / {{ _totalPageCount }}</span>
    </div>
    
    <button
      id="reports-btn-next"
      [disabled]="!_NextHidden || _currentPageNumber >= _totalPageCount"
      type="button"
      class="btn btn-secondary mx-2 text-nowrap mb-2 mb-sm-0"
      (click)="movePage(1)"
    >
      {{ _appService.CoreCommonLiterals.NextPage }} <span>&raquo;</span>
    </button>
    
    <button 
      id="reports-btn-last"
      [disabled]="!_NextHidden || _currentPageNumber >= _totalPageCount"
      type="button"
      class="btn btn-secondary mx-2 text-nowrap mb-2 mb-sm-0"
      (click)="movePage(1, true)"
    > 
      {{ _appService.CoreCommonLiterals.LastPage }} <span>&rsaquo;</span>
    </button>
  </div>
  <hr>
</div>
